import { debounce } from "lodash";
import { SELECTORS } from "../constants.js";

function onTrigger($parse) {
	return {
		scope: {
			fn: "&onTrigger"
		},

		link: function(scope, element, attrs) {

			const onTriggerHandler = debounce(() => scope.$apply(scope.fn()), 200, { "leading": true, "trailing": false });

			element.on("click", function() {
				if(
					!$parse(attrs.ignoreClick || "false")(scope)
				) {
					onTriggerHandler();
				}
			});

			element.on("keyup", function(event) {
				if(
					(
						(!$parse(attrs.ignoreSpace || "false")(scope) && event.keyCode == 32) //if not space is ignored and key is space
						|| (!$parse(attrs.ignoreEnter || "false")(scope) && event.keyCode == 13) //if not enter is ignored and key is enter
					)
				) {
					onTriggerHandler();

					if(attrs.onTriggerFocus) {
						//find an element to target "within"
						const target = document.querySelector(attrs.onTriggerFocus);

						//find an element within the target that is selectable
						const tabbee = target.querySelector(SELECTORS.TabbableElements);

						//focus it
						tabbee.focus();
					}
				}
			});
		}
	};
}

export default angular
	.module("vesl.behaviors.on-trigger", [])
	.directive("onTrigger", onTrigger).name;
